module.exports = __webpack_public_path__ + "img/Gite_d_en_Lebe016.f6144e38.jpg";